import { vIcon, xIcon } from '@/assets/images/icons';
import {
  getAccessibilityScoreDic,
  ScoreCardProps,
  ScoreContent,
} from '../AccessibilityScore.consts';
import { Icon } from '@/shared/components/Icon';
import { StyledCol, StyledTitle } from '@/shared/styles';
import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';
import { StyledScore } from './ScoreCard.styles';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ScoreCard: React.FC<ScoreCardProps> = ({ $scoreName }: ScoreCardProps) => {
  const { accessibilityScore, getAmountOfIssues, isAuditPassed } = useAccessibilityCheckerStore();
  const [scoreDic, setScoreDic] = useState<ScoreContent | undefined>();
  const { t } = useTranslation();

  useEffect(() => {
    if (accessibilityScore !== undefined) {
      const accessibilityScoreDic = getAccessibilityScoreDic(
        accessibilityScore,
        getAmountOfIssues()
      );
      setScoreDic(accessibilityScoreDic[$scoreName][isAuditPassed() ? 'passed' : 'failed']);
    }
  }, [accessibilityScore]);

  return (
    scoreDic && (
      <StyledCol $gap={16}>
        <StyledTitle level={3}>
          {t(`free_tools.accessibility_checker.a11y_results.${$scoreName}`)}
        </StyledTitle>
        <StyledScore>
          {<Icon $src={isAuditPassed() ? vIcon : xIcon} />}
          {scoreDic.score}
        </StyledScore>
        {scoreDic.content}
      </StyledCol>
    )
  );
};
